<script setup lang="ts">
import {RefreshCcw04} from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import {useRouter} from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
}

const goHome = () => {
  router.push("/");
}
</script>

<template>
  <div class="v-error">
    <div class="main">
      <div class="main__content">
        404
      </div>

      <div class="main__headline">
        Page not found
      </div>

      <div class="main__description">
        The page you’re looking for doesn’t exist or may have been moved. Please check the URL or go back to the
        homepage.
      </div>

      <div class="main__action">
        <CommonButton @click="goBack" type="outline" prepend :prepend-icon="RefreshCcw04"
                      label="Refresh"></CommonButton>
        <CommonButton @click="goHome" type="primary" label="Go to home"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>